module.exports = __webpack_public_path__ + "iconfont.svg?2f95f0701928b8b63e02561dc8d6fa18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1612683013658
// module id = 26
// module chunks = 0